import { Dimensions, StyleSheet } from "react-native"
import { baseColors, basePadding } from "@Constants/baseStyles"
const { height } = Dimensions.get("screen")
const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white
    },
    content: {
        paddingHorizontal: basePadding.paddingHorizontal,
        paddingTop: basePadding.paddingVertical,
        height: height / 2 + 120
    },
    helloUser: {
        color: baseColors.green.primary,
        marginBottom: 12
    },
    icon: { position: "absolute", top: 20, right: 15, alignSelf: "flex-end" },
    knowledgeContent: {
        overflow: "hidden",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    otherInfos: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    header: {
        paddingBottom: 18
    }
})

export default styles
